import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnablePlanFeaturesTrialUpsell = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enablePlanFeaturesTrialUpsell);
};
